<div *ngIf="timelineActive === true && acoes.length > 0">
    <div class="sos attended">
        <a class="bar">
            <span class="icon"></span>
            <h3>SOS Atendido</h3>
            <div class="item-respondido" *ngFor="let item of acoes">
                <div *ngIf="item.acao === 'INCLUIR_AVAL'">
                    <span class="subtitle">- Avalista Adicionado; </span>
                </div>

                <div *ngIf="item.acao === 'GRAVAR_DOCS'">
                    <span class="subtitle">- Documentação Anexada; </span>
                </div>

                <div *ngIf="item.acao === 'GRAVAR_OBS'">
                    <span class="subtitle">- Observação Adicionada; </span>
                </div>
            </div>
        </a>
    </div>
</div>